angular
  .module('contrast.roles.constants', [])
  .constant('ROLE_ADMIN', {
    applications: [
      { value: true, label: 'Archive' },
      { value: true, label: 'Delete' },
      { value: true, label: 'Edit' },
      { value: true, label: 'License' },
      { value: true, label: 'Merge' },
      { value: true, label: 'Reset' },
      { value: true, label: 'Restore' },
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    vulnerabilities: [
      { value: true, label: 'Delete' },
      { value: true, label: 'Discussion' },
      { value: true, label: 'Edit' },
      { value: true, label: 'Export' },
      { value: true, label: 'HTTP Replay' },
      { value: true, label: 'Merge' },
      { value: true, label: 'Send to Bugtracker' },
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    report: [{ value: true, label: 'Generate' }],
    architecture: [{ value: true, label: 'View' }],
    app_policy: [
      { value: true, label: 'Edit' },
      { value: true, label: 'View' }
    ],
    exclusions: [
      { value: true, label: 'Create' },
      { value: true, label: 'View' }
    ],
    general: [
      { value: true, label: 'Org Info' },
      { value: true, label: 'Report Settings' },
      { value: true, label: 'Score Settings' }
    ],
    servers: [
      { value: true, label: 'Delete' },
      { value: true, label: 'Edit' },
      { value: true, label: 'License' },
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    security: [
      { value: true, label: 'Audit' },
      { value: true, label: 'Get API Keys' },
      { value: true, label: 'IP Range' },
      { value: true, label: 'Rotate API Keys' },
      { value: true, label: 'Password Policy' },
      { value: true, label: 'Session Timeouts' }
    ],
    integrations: [
      { value: true, label: 'Edit' },
      { value: true, label: 'View' }
    ],
    libraries: [
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    policy: [
      { value: true, label: 'App Exclusions' },
      { value: true, label: 'Assess Rules' },
      { value: true, label: 'Library Policy' },
      { value: true, label: 'Protection Policy' },
      { value: true, label: 'Remediation Policy' }
    ]
  })
  .constant('ROLE_RULES_ADMIN', {
    applications: [
      { value: true, label: 'Archive' },
      { value: false, label: 'Delete' },
      { value: false, label: 'Edit' },
      { value: false, label: 'License' },
      { value: true, label: 'Merge' },
      { value: false, label: 'Reset' },
      { value: true, label: 'Restore' },
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    vulnerabilities: [
      { value: true, label: 'Delete' },
      { value: true, label: 'Discussion' },
      { value: true, label: 'Edit' },
      { value: true, label: 'Export' },
      { value: true, label: 'HTTP Replay' },
      { value: true, label: 'Merge' },
      { value: true, label: 'Send to Bugtracker' },
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    report: [{ value: true, label: 'Generate' }],
    architecture: [{ value: true, label: 'View' }],
    app_policy: [
      { value: true, label: 'Edit' },
      { value: true, label: 'View' }
    ],
    exclusions: [
      { value: true, label: 'Create' },
      { value: true, label: 'View' }
    ],
    general: [
      { value: true, label: 'Org Info' },
      { value: false, label: 'Report Settings' },
      { value: true, label: 'Score Settings' }
    ],
    servers: [
      { value: false, label: 'Delete' },
      { value: false, label: 'Edit' },
      { value: false, label: 'License' },
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    security: [
      { value: false, label: 'Audit' },
      { value: true, label: 'Get API Keys' },
      { value: false, label: 'IP Range' },
      { value: false, label: 'Rotate API Keys' },
      { value: false, label: 'Password Policy' },
      { value: false, label: 'Session Timeouts' }
    ],
    integrations: [
      { value: false, label: 'Edit' },
      { value: false, label: 'View' }
    ],
    libraries: [
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    policy: [
      { value: true, label: 'App Exclusions' },
      { value: true, label: 'Assess Rules' },
      { value: true, label: 'Library Policy' },
      { value: true, label: 'Protection Policy' },
      { value: true, label: 'Remediation Policy' }
    ]
  })
  .constant('ROLE_EDIT', {
    applications: [
      { value: true, label: 'Archive' },
      { value: false, label: 'Delete' },
      { value: false, label: 'Edit' },
      { value: false, label: 'License' },
      { value: true, label: 'Merge' },
      { value: false, label: 'Reset' },
      { value: true, label: 'Restore' },
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    vulnerabilities: [
      { value: true, label: 'Delete' },
      { value: true, label: 'Discussion' },
      { value: true, label: 'Edit' },
      { value: true, label: 'Export' },
      { value: true, label: 'HTTP Replay' },
      { value: true, label: 'Merge' },
      { value: true, label: 'Send to Bugtracker' },
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    report: [{ value: true, label: 'Generate' }],
    architecture: [{ value: false, label: 'View' }],
    app_policy: [
      { value: false, label: 'Edit' },
      { value: true, label: 'View' }
    ],
    exclusions: [
      { value: false, label: 'Create' },
      { value: true, label: 'View' }
    ],
    general: [
      { value: true, label: 'Org Info' },
      { value: false, label: 'Report Settings' },
      { value: true, label: 'Score Settings' }
    ],
    servers: [
      { value: false, label: 'Delete' },
      { value: false, label: 'Edit' },
      { value: false, label: 'License' },
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    security: [
      { value: false, label: 'Audit' },
      { value: true, label: 'Get API Keys' },
      { value: false, label: 'IP Range' },
      { value: false, label: 'Rotate API Keys' },
      { value: false, label: 'Password Policy' },
      { value: false, label: 'Session Timeouts' }
    ],
    integrations: [
      { value: false, label: 'Edit' },
      { value: false, label: 'View' }
    ],
    libraries: [
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    policy: [
      { value: false, label: 'App Exclusions' },
      { value: false, label: 'Assess Rules' },
      { value: false, label: 'Library Policy' },
      { value: false, label: 'Protection Policy' },
      { value: false, label: 'Remediation Policy' }
    ]
  })
  .constant('ROLE_VIEW', {
    applications: [
      { value: false, label: 'Archive' },
      { value: false, label: 'Delete' },
      { value: false, label: 'Edit' },
      { value: false, label: 'License' },
      { value: false, label: 'Merge' },
      { value: false, label: 'Reset' },
      { value: false, label: 'Restore' },
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    vulnerabilities: [
      { value: false, label: 'Delete' },
      { value: false, label: 'Discussion' },
      { value: false, label: 'Edit' },
      { value: true, label: 'Export' },
      { value: true, label: 'HTTP Replay' },
      { value: false, label: 'Merge' },
      { value: false, label: 'Send to Bugtracker' },
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    report: [{ value: false, label: 'Generate' }],
    architecture: [{ value: false, label: 'View' }],
    app_policy: [
      { value: false, label: 'Edit' },
      { value: true, label: 'View' }
    ],
    exclusions: [
      { value: false, label: 'Create' },
      { value: true, label: 'View' }
    ],
    general: [
      { value: true, label: 'Org Info' },
      { value: false, label: 'Report Settings' },
      { value: true, label: 'Score Settings' }
    ],
    servers: [
      { value: false, label: 'Delete' },
      { value: false, label: 'Edit' },
      { value: false, label: 'License' },
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    security: [
      { value: false, label: 'Audit' },
      { value: true, label: 'Get API Keys' },
      { value: false, label: 'IP Range' },
      { value: false, label: 'Rotate API Keys' },
      { value: false, label: 'Password Policy' },
      { value: false, label: 'Session Timeouts' }
    ],
    integrations: [
      { value: false, label: 'Edit' },
      { value: false, label: 'View' }
    ],
    libraries: [
      { value: true, label: 'Tag' },
      { value: true, label: 'View' }
    ],
    policy: [
      { value: false, label: 'App Exclusions' },
      { value: false, label: 'Assess Rules' },
      { value: false, label: 'Library Policy' },
      { value: false, label: 'Protection Policy' },
      { value: false, label: 'Remediation Policy' }
    ]
  })
